module.exports = __webpack_public_path__ + "img/c08_buildingtechkarma_Normal_ua.0a7edbdd.webp";